import React from 'react';
import styles from './FullLoginForm.module.scss';
import { Button, Icon, Textarea } from '@toctoc/design-system';
import { IFullLoginFormProps } from './FullLoginForm.interface';
import { useRouter } from 'next/router';

export const FullLoginForm: React.FC<IFullLoginFormProps> = ({ imgSrc, children, uri }) => {

	const router = useRouter();

	const goBackButtonHandler = () => {
		if (uri) {
			router.push(uri as string)
		} else {
			router.push('/login');
		}
	}

	return (
		<div className={styles.fullLoginFormCtr}>
			<div className={styles.backgroundCtr} />
			<div className={styles.goBackButtonCtr}>
				<Button onClick={goBackButtonHandler} texto='Volver' variant='text' disableRipple disableFocusRipple style={{ backgroundColor: 'transparent', fontWeight: 700 }} startIcon={<Icon className='btn-icono' name='chevron-left' size={24} color={'#3200c1'} />} />
			</div>
			<div className={styles.imgCtr}>
				<img src={imgSrc} />
			</div>
			{children}
		</div>
	)
}

export default FullLoginForm;